import React, { Component } from 'react';
import './style.scss';
import { Tabs } from 'antd'
import PropTypes from 'prop-types'
import FormSetting from './components/FormSetting';
import { withRouter } from "react-router";
import { getQuiz, updateQuiz, getRooms, getBranch, getSource, getCategories, getSubcategories, getSubjects, deleteQuestionQuiz } from './actions';
import {toastr} from 'react-redux-toastr'
import Questions from './components/Questions';
import moment from 'moment';
import Spiner from '../helpers/Spiner/Spiner';

const { TabPane } = Tabs;

class Quiz extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      quiz: {},
      questions: [],
      rooms: [],
      categories: [],
      subcategories: [],
      subjects: [],
      branches: [],
      sources: [],
      loaded: false,
    }
  }

  async componentDidMount(){
    const { match, history } = this.props;
    try {
      if(match.params && match.params.id){

        const [data, rooms, categories, subcategories, subjects, branches, sources] = await Promise.all([
          getQuiz(match.params.id),
          getRooms(),
          getCategories(),
          getSubcategories(),
          getSubjects(),
          getBranch(),
          getSource(),
        ])


        const active = data.model.active == 1 ? moment() >= moment(data.model.active_from * 1000) && moment() <= moment(data.model.active_to * 1000) ? 1 : 0 : 0;

        this.setState({
          quiz: {
            ...data.model,
            active_to: data.model.active_to * 1000,
            active_from: data.model.active_from * 1000,
            active
          },
          rooms,
          questions: data.questions,
          categories,
          subcategories,
          subjects,
          branches,
          sources,
          loaded: true
        })
      } else {
        history.push('/quizs')
      }

    } catch (error) {
      history.push('/quizs')
    }
  }

  onSave = async (values) => {
    try {
      const {formatMessage} = this.context;
      const data = await updateQuiz(values);
      this.setState({quiz: {
        ...data,
        active_to: data.active_to * 1000,
        active_from: data.active_from * 1000,
      }});
      toastr.success(formatMessage('msgNotificationQuiz'), formatMessage('msgNotificationQuizUpdated'))
    } catch (error) {
      toastr.error('Error', error.message);
    }
  }
  
  deleteQuizQuestion = async (quiz_id, question_id) => {
    await deleteQuestionQuiz({quiz_id, questions: [question_id]});
    const {questions} = this.state;
    this.setState({questions: questions.filter(item => item.id != question_id)})
  }

  render() {
    const {formatMessage} = this.context
    const {quiz, rooms, questions, categories, subcategories, subjects, loaded, branches,sources } = this.state;
    const {history, match} = this.props;


    if(!loaded) {
      return <Spiner/>;
    }

    return (
      <div className="qbm-content Quiz">
				<div className="quiz-tabs">
        <Tabs type="card">
          <TabPane tab={formatMessage('txtMessageQuizSettings')} key="1">
            <FormSetting
              initialValues={quiz} 
              history={history} 
              onSave={this.onSave} 
              rooms={rooms} 
            />
          </TabPane>
          <TabPane tab={formatMessage('txtMessageQuizQuestions')} key="2">
            <Questions
              questions={questions}
              categories={categories}
              subcategories={subcategories}
              subjects={subjects}
              branches={branches}
              sources={sources}
              deleteQuizQuestion={this.deleteQuizQuestion}
              quiz_id={match.params.id}
            />
          </TabPane>
        </Tabs>
        </div>
      </div>
    );
  }
}

export default withRouter(Quiz);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quiz/Quiz.jsx